import React from "react";
import { Save, Loader2 } from "lucide-react";
import { FETISH_PRESETS, SERVICE_PRESETS, PROFILE_FIELDS } from "../lib/profilePresets";
import BookingGalleryManager from "./BookingGalleryManager";

export default function CompanionProfileSettings({ 
  profileSettings, 
  updateProfileAttr, 
  toggleService, 
  toggleFetish,
  updateGalleryPhotos,
  saveProfileSettings,
  settingsLoading 
}) {
  
  const Pill = ({ label, selected, onClick }) => (
    <button
      type="button"
      onClick={onClick}
      className={`px-3 py-1.5 rounded-full text-sm font-medium transition ${
        selected
          ? "bg-purple-500 text-white"
          : "bg-gray-800 text-gray-300 hover:bg-gray-700"
      }`}
    >
      {label}
    </button>
  );

  return (
    <div className="space-y-6">
      {/* Save Button at Top */}
      <div className="flex justify-end">
        <button
          onClick={saveProfileSettings}
          disabled={settingsLoading}
          className="px-6 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg font-medium transition flex items-center gap-2 disabled:opacity-50"
        >
          {settingsLoading ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" />
              Saving...
            </>
          ) : (
            <>
              <Save className="w-4 h-4" />
              Save Settings
            </>
          )}
        </button>
      </div>

      {/* Profile Attributes */}
      <div className="bg-gray-800/50 rounded-lg p-6 border border-gray-700">
        <h3 className="text-lg font-bold text-white mb-4">Physical Stats & Attributes</h3>
        <p className="text-sm text-gray-400 mb-6">
          These settings control what appears on your public booking/escort profile
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {PROFILE_FIELDS.map((field) => (
            <div key={field.key}>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                {field.label}
              </label>
              {field.options.length > 0 ? (
                <select
                  value={profileSettings.profile_attrs[field.key] || ""}
                  onChange={(e) => updateProfileAttr(field.key, e.target.value)}
                  className="w-full px-3 py-2 bg-gray-900 border border-gray-700 rounded-lg text-white focus:border-purple-500 focus:outline-none"
                >
                  <option value="">Select...</option>
                  {field.options.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  type="text"
                  value={profileSettings.profile_attrs[field.key] || ""}
                  onChange={(e) => updateProfileAttr(field.key, e.target.value)}
                  className="w-full px-3 py-2 bg-gray-900 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:border-purple-500 focus:outline-none"
                  placeholder={`Enter ${field.label.toLowerCase()}...`}
                />
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Services */}
      <div className="bg-gray-800/50 rounded-lg p-6 border border-gray-700">
        <h3 className="text-lg font-bold text-white mb-2">Services You Offer</h3>
        <p className="text-sm text-gray-400 mb-4">
          Select the services you provide ({profileSettings.services_offered.length} selected)
        </p>
        <div className="flex flex-wrap gap-2">
          {SERVICE_PRESETS.map((service) => (
            <Pill
              key={service}
              label={service}
              selected={profileSettings.services_offered.includes(service)}
              onClick={() => toggleService(service)}
            />
          ))}
        </div>
      </div>

      {/* Fetishes */}
      <div className="bg-gray-800/50 rounded-lg p-6 border border-gray-700">
        <h3 className="text-lg font-bold text-white mb-2">Fetishes & Interests</h3>
        <p className="text-sm text-gray-400 mb-4">
          Select fetishes you're into ({profileSettings.fetishes_offered.length} selected)
        </p>
        <div className="flex flex-wrap gap-2">
          {FETISH_PRESETS.map((fetish) => (
            <Pill
              key={fetish}
              label={fetish}
              selected={profileSettings.fetishes_offered.includes(fetish)}
              onClick={() => toggleFetish(fetish)}
            />
          ))}
        </div>
      </div>

      <BookingGalleryManager
        photos={profileSettings.gallery_photos || []}
        onChange={updateGalleryPhotos}
      />

      {/* Save Button at Bottom */}
      <div className="flex justify-end">
        <button
          onClick={saveProfileSettings}
          disabled={settingsLoading}
          className="px-6 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg font-medium transition flex items-center gap-2 disabled:opacity-50"
        >
          {settingsLoading ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" />
              Saving...
            </>
          ) : (
            <>
              <Save className="w-4 h-4" />
              Save Settings
            </>
          )}
        </button>
      </div>
    </div>
  );
}
